import React from 'react';
import { Row, Col, Container, Nav } from 'react-bootstrap';

export default function Footer() {
    return (
        <Nav className="footer">
            <Container>
                <Row className='justify-content-center'>
                    <Col sm={4}>
                        <img className="logo" src="/images/Clearpoint-Logo-White@2x.png" alt="Clearpoint Logo"/>
                    </Col>
                    <Col sm={4}>
                        <label>Address</label>
                        <address>
                            P.O. Box 59<br/>
                            Batesville, IN 47006
                        </address>
                    </Col>
                    <Col sm={4}>
                        <label>Contact Us</label>
                        <address>
                            (800) 763-0234 <br/>
                            <a href="mailto:customer.service@clearpointfederal.com">customer.service@clearpointfederal.com</a>
                        </address>
                    </Col>
                </Row>
            </Container>
        </Nav>
    );
}
